export const addQueryParamsToUrl = (url: string, params: Record<string, string | number | boolean>) => {
    const urlObj = new URL(url);

    const hashFragment = urlObj.hash;
    const [path, queryString] = hashFragment.replace('#', '').split('?');

    const searchParams = new URLSearchParams(queryString);

    for (const [key, value] of Object.entries(params)) {
        if (value !== undefined) {
            searchParams.append(key, String(value));
        }
    }

    const searchParamsString = searchParams.size > 0 ? `?${searchParams.toString()}` : '';
    const hashString = path ? `#${path}` : '';
    const newUrl = `${urlObj.origin}${urlObj.pathname}${hashString}${searchParamsString}`;

    return newUrl.toString();
};
